import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpRequest} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class OtpSessionHttpService {

    private readonly baseUrl = '/front/paynow/otp/session';

    constructor(private http: HttpClient) {}

    public buyOtpSession(otpSessionRef: string, contextId: string): Observable<HttpRequest<any>> {
        return this.http.put<HttpRequest<any>>(`${this.baseUrl}/${otpSessionRef}/${contextId}`, {});
    };

}
